import React from "react";
import PropTypes from 'prop-types';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import logoSignature from "../../../IB_Signature.png";
import HighchartsMore from "highcharts/highcharts-more";
import { updateChartTheme } from "src/utils/helpsers";

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
HighchartsMore(Highcharts);

/**
 * Tornado chart using highcharts library.
 * @param {object} data - An array data to be rendered in the chart.
 * @param {string} title - The title of the chart.
 * @param {string} subtitle - Text to define the subtitle.
 * @returns {JSX.Element}
 */
const TornadoChart = ({ data, title, subtitle = null }) => {

  let categories = data.categories;
  let logoCredit;

  const tornadoData = {
    chart: {
      type: "bar",
      height: 550,
      backgroundColor: '#fff',
      accessibility: {
        enabled: false
      },
      style: {
        fontFamily: ['Titillium Web', 'sans-serif']
      },
      margin: [100, 50, 120, 120],
      events: {
        exportData: function(data) {
          (data.dataRows).forEach( (row, parentKey) => {
            row.forEach( (val, key) => {
              if(typeof val === 'number' && val < 0) {
                return data.dataRows[parentKey][key] = val * -1;
              }
            });
          });
        },
        load: function () {
          if (this.options.chart.forExport) {
            this.renderer.image(`${logoSignature}`, 10, 520, 160, 25).add();
          }
        },
        beforePrint: function () {
          logoCredit = this.renderer
            .image(`${logoSignature}`, 10, 520, 160, 25)
            .add();
          this.print();
        },
        afterPrint: function () {
          logoCredit.element.remove();
        },
      },
    },
    title: {
      text: '<b>' + title + '</b>',
      style: { "fontSize": "15px" }
    },
    subtitle: {
      text: subtitle,
      style: {
        fontSize: '14px',
      },
    },
    xAxis: [
      {
        categories: categories,
        reversed: true,
        labels: {
          style: {
            fontWeight: 'bold',
          }
        }
      },
    ],
    yAxis: {
      max: 100,
      min: -100,
      labels: {
        formatter: function () {
          return Math.abs(this.value) + "%";
        },
      },
    },
    plotOptions: {
      series: {
        stacking: "normal",
      },
    },

    exporting: {
      tableCaption: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            {
              text: "Toggle Light/Dark mode",
              onclick:  function() {
                updateChartTheme(this);
              }
            },
            {
              separator: true,
            },
            {
              text: "Download PDF document",
              onclick: function () {
                window._paq.push([
                  "trackEvent",
                  "Board DistrictInsights",
                  `Downloaded: PDF in ${title}`,
                ]);
                this.exportChart({
                  type: "application/pdf",
                });
              },
            },
            {
              text: "Download CSV",
              onclick: function () {
                window._paq.push([
                  "trackEvent",
                  "Board DistrictInsights",
                  `Downloaded: CSV in ${title}`,
                ]);
                this.downloadCSV();
              },
            },
            {
              text: "Download XLS",
              onclick: function () {
                window._paq.push([
                  "trackEvent",
                  "Board DistrictInsights",
                  `Downloaded: XLS in ${title}`,
                ]);
                this.downloadXLS();
              },
            },
            {
              separator: true,
            },
            {
              text: 'Toggle Raw Data Table',
              onclick: function() {
                if (this.dataTableDiv && this.dataTableDiv.style.display !== 'none') {
                  this.dataTableDiv.style.display = 'none';
                } else {
                  this.viewData();
                  this.dataTableDiv.style.display = '';
                }
              }
            }
          ],
        },
      },
    },

    tooltip: {
      formatter: function () {
        return (
          "<b>" +
          this.point.category +
          "</b><br/>" +
          "Percentage of Total: " +
          Highcharts.numberFormat(Math.abs(this.point.y), 1) +
          "%"
        );
      },
      backgroundColor: "#FFF",
    },

    series: [
      data.students,
      data.teachers,
    ],

    colors: [
      '#9056D6',
      '#FFCC4E',
    ],
  };
  return <HighchartsReact highcharts={Highcharts} options={tornadoData}/>;
};

TornadoChart.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default React.memo(TornadoChart);
